<template>
  <div class="c-preview">
    <template v-if="zipFileList.length > 1">
      <c-new-zip-preview :zip-file-list="zipFileList"></c-new-zip-preview>
    </template>
    <template v-else-if="zipFileList.length === 1">
      <c-new-image-preview
        :listImg="fileDetail.pics"
        :picsCount="fileDetail.picsCount"
      >
      </c-new-image-preview>
    </template>
    <template v-else-if="zipFileList.length === 0 && !loading">
      <c-zip-preview v-if="isZip(fileDetail.suffixType)" :file="fileDetail"></c-zip-preview>
      <c-office-preview v-else-if="isOffice(fileDetail.suffixType)" :file="fileDetail"></c-office-preview>
      <div class="unble-preview" v-else>
        <div class="unble-preview-wrap">
          <img src="../images/no_data.png" alt>
          <p>无法预览！！！</p>
          <p>当前文档不提供在线查看，请下载使用</p>
        </div>
      </div>
    </template>
    <p class="c-preview-loading" v-else>
      加载中...
    </p>
  </div>
</template>

<script>
import mixins from '../mixins/resourceProduction';
import CNewImagePreview from './CNewImagePreview';
import CNewZipPreview from './CNewZipPreview';
import COfficePreview from './COfficePreview';
import CZipPreview from './CZipPreview';

export default {
  name: 'c-preview',
  mixins: [mixins],
  components: {
    CNewImagePreview,
    CNewZipPreview,
    COfficePreview,
    CZipPreview
  },
  props: {
    id: {
      type: Number | String,
      default: ''
    },
    subfix: {
      type: String,
      default: ''
    },
    file: {
      type: Array
    },
  },
  data() {
    return {
      fileDetail: {},
      zipFileList: [],
      loading: true
    }
  },
  watch: {
    file(newValue, oldValue) {
      if (newValue) {
        this.dealFile(newValue)
      }
    }
  },
  mounted() {
    if (this.file) {
      this.dealFile(this.file)
    }
  },
  methods: {
    dealFile(res) {
      res = res.filter(item => {
      // 有些压缩软件压缩的路径是反斜杠，比如wode123，阿里云在转码的时候会乱码，用zip的方式去预览，先都按这个规则处理
        return item.fileAddress.indexOf('\\') === -1
      })
      if (res.length > 1) {
        this.zipFileList = res.map(item => {
          let filename = item.fileAddress.split('/').pop();
          return {
            ...item,
            name: filename.split('.')[0],
            suffixType: item.suffixType || filename.split('.')[1]
          }
        });
      }
      else if (res.length === 1) {
        // 转完
        if (res[0].status === 'Finished') {
          this.zipFileList = res;
        }
        this.fileDetail = {
          ...res[0],
          name: 'file',
          pics: res[0].pictureUrls,
          suffixType: res[0].suffixType || res[0].fileAddress.split('.').pop()
        }
      }
      else {
        this.fileDetail = {
          name: 'file',
          id: this.$props.id,
          type: '',
          suffixType: this.$props.subfix
        }
      }
      this.loading = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.c-preview {
  .unble-preview-wrap {
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    height: 550px;
    border: 1px solid #e1e1e1;

    .download {
      margin-top: 16px;
      border-radius: 4px;
      font-size: 16px;
    }

    p {
      line-height: 36px;
    }
  }

  .c-preview-loading {
    text-align: center;
    margin-top: 300px;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/previewV2/components/CPreview.vue